import Vue from 'vue';
import bus from 'lib/bus';

export default (el) =>
  new Vue({
    components: {
      'footer-signup': () => import('../footer-signup/footer-signup.vue'),
      'footer-notification': () =>
        import('../footer-notification/footer-notification.vue'),
      socials: () => import('../socials/socials.vue'),
      'socials-multi': () => import('../socials-multi/socials-multi.vue'),
      accordion: () => import('../accordion/accordion.vue'),
    },
    el,
    data: () => ({
      showNotification: false,
    }),
    methods: {
      toggleNotification(value = null) {
        if (value !== null) {
          this.showNotification = value;
        } else {
          this.showNotification = !showNotification;
        }
      },
      onClickCountryTrigger() {
        bus.$emit('show-country-selector-panel');
      }
    },
  });
